const options = [
  {
    label: "等于",
    value: "eq",
  },
  {
    label: "不等于",
    value: "ne",
  },
  {
    label: "等于任意一个",
    value: "in",
  },
  {
    label: "不等于任意一个",
    value: "nin",
  },
  {
    label: "包含",
    value: "like",
  },
  {
    label: "不包含",
    value: "unlike",
  },
  {
    label: "为空",
    value: "empty",
  },
  {
    label: "不为空",
    value: "not_empty",
  },
];

export const filterData = {
  TextInput: {
    options,
  },
  TextareaInput: {
    options: [
      {
        label: "包含",
        value: "like",
      },
      {
        label: "不包含",
        value: "unlike",
      },
      {
        label: "为空",
        value: "empty",
      },
      {
        label: "不为空",
        value: "not_empty",
      },
    ],
  },
  AmountInput: {
    options: [
      {
        label: "等于",
        value: "eq",
      },
      {
        label: "不等于",
        value: "ne",
      },
      {
        label: "大于",
        value: "gt",
      },
      {
        label: "大于等于",
        value: "gte",
      },
      {
        label: "小于",
        value: "lt",
      },
      {
        label: "小于等于",
        value: "lte",
      },
      {
        label: "选择范围",
        value: "range",
      },
      {
        label: "为空",
        value: "empty",
      },
      {
        label: "不为空",
        value: "not_empty",
      },
    ],
  },
  SelectInput: {
    options,
  },
  MultipleSelect: {
    options: [
      {
        label: "包含任意一个",
        value: "like",
      },
      {
        label: "同时包含",
        value: "all",
      },
      {
        label: "等于",
        value: "eq",
      },
      {
        label: "为空",
        value: "empty",
      },
      {
        label: "不为空",
        value: "not_empty",
      },
    ],
  },
  DateTime: {
    options: [
      {
        label: "等于",
        value: "eq",
      },
      {
        label: "不等于",
        value: "ne",
      },
      {
        label: "大于等于",
        value: "gte",
      },
      {
        label: "小于等于",
        value: "lte",
      },
      {
        label: "为空",
        value: "empty",
      },
      {
        label: "不为空",
        value: "not_empty",
      },
    ],
  },
  UserPicker: {
    options: [
      {
        label: "等于",
        value: "eq",
      },
      {
        label: "不等于",
        value: "ne",
      },
      {
        label: "等于任意一个",
        value: "in",
      },
      {
        label: "不等于任意一个",
        value: "nin",
      },
      {
        label: "为空",
        value: "empty",
      },
      {
        label: "不为空",
        value: "not_empty",
      },
    ],
  },
  ImageUpload: {
    options: [
      {
        label: "为空",
        value: "empty",
      },
      {
        label: "不为空",
        value: "not_empty",
      },
    ],
  },
  FileUpload: {
    options: [
      {
        label: "为空",
        value: "empty",
      },
      {
        label: "不为空",
        value: "not_empty",
      },
    ],
  },
  MultipleUserPicker: {
    options: [
      {
        label: "包含任意一个",
        value: "like",
      },
      {
        label: "同时包含",
        value: "all",
      },
      {
        label: "等于",
        value: "eq",
      },
      {
        label: "为空",
        value: "empty",
      },
      {
        label: "不为空",
        value: "not_empty",
      },
    ],
  },
  DeptPicker: {
    options: [
      {
        label: "等于",
        value: "eq",
      },
      {
        label: "不等于",
        value: "ne",
      },
      {
        label: "为空",
        value: "empty",
      },
      {
        label: "不为空",
        value: "not_empty",
      },
      {
        label: "等于任意一个",
        value: "in",
      },
      {
        label: "不等于任意一个",
        value: "nin",
      },
    ],
  },
  MultipleDeptPicker: {
    options: [
      {
        label: "包含任意一个",
        value: "like",
      },
      {
        label: "同时包含",
        value: "all",
      },
      {
        label: "等于",
        value: "eq",
      },
      {
        label: "为空",
        value: "empty",
      },
      {
        label: "不为空",
        value: "not_empty",
      },
    ],
  },
  Relevance: {
    options: [
      {
        label: "等于",
        value: "eq",
      },
      {
        label: "不等于",
        value: "ne",
      },
      {
        label: "为空",
        value: "empty",
      },
      {
        label: "不为空",
        value: "not_empty",
      },
    ],
  },
  MultipleRelevance: {
    options: [
      {
        label: "包含任意一个",
        value: "like",
      },
      {
        label: "同时包含",
        value: "all",
      },
      {
        label: "等于",
        value: "eq",
      },
      {
        label: "为空",
        value: "empty",
      },
      {
        label: "不为空",
        value: "not_empty",
      },
    ],
  },
  Status: {
    options: [
      {
        label: "等于",
        value: "eq",
      },
      {
        label: "不等于",
        value: "ne",
      },
    ],
  },
  Name: {
    options: [
      {
        label: "等于",
        value: "eq",
      },
      {
        label: "不等于",
        value: "ne",
      },
    ],
  },
  City: {
    options: [
      {
        label: "属于",
        value: "all",
      },
      {
        label: "不属于",
        value: "nin",
      },
      {
        label: "为空",
        value: "empty",
      },
      {
        label: "不为空",
        value: "not_empty",
      },
    ],
  },
  SerialNumber: {
    options: [
      {
        label: "等于",
        value: "eq",
      },
      {
        label: "不等于",
        value: "ne",
      },
      {
        label: "为空",
        value: "empty",
      },
      {
        label: "不为空",
        value: "not_empty",
      },
      {
        label: "等于任意一个",
        value: "in",
      },
      {
        label: "不等于任意一个",
        value: "nin",
      },
    ],
  },
  CreatedBy: {
    options: [
      {
        label: "等于",
        value: "eq",
      },
      {
        label: "不等于",
        value: "ne",
      },
      {
        label: "为空",
        value: "empty",
      },
      {
        label: "不为空",
        value: "not_empty",
      },
      {
        label: "等于任意一个",
        value: "in",
      },
      {
        label: "不等于任意一个",
        value: "nin",
      },
    ],
  },
  OwnerId: {
    options: [
      {
        label: "等于",
        value: "eq",
      },
      {
        label: "不等于",
        value: "ne",
      },
      {
        label: "为空",
        value: "empty",
      },
      {
        label: "不为空",
        value: "not_empty",
      },
      {
        label: "等于任意一个",
        value: "in",
      },
      {
        label: "不等于任意一个",
        value: "nin",
      },
    ],
  },
  UpdatedBy: {
    options: [
      {
        label: "等于",
        value: "eq",
      },
      {
        label: "不等于",
        value: "ne",
      },
      {
        label: "为空",
        value: "empty",
      },
      {
        label: "不为空",
        value: "not_empty",
      },
      {
        label: "等于任意一个",
        value: "in",
      },
      {
        label: "不等于任意一个",
        value: "nin",
      },
    ],
  },
  CreatedDept: {
    options: [
      {
        label: "等于",
        value: "eq",
      },
      {
        label: "不等于",
        value: "ne",
      },
      {
        label: "为空",
        value: "empty",
      },
      {
        label: "不为空",
        value: "not_empty",
      },
      {
        label: "等于任意一个",
        value: "in",
      },
      {
        label: "不等于任意一个",
        value: "nin",
      },
    ],
  },
  OwnerDeptId: {
    options: [
      {
        label: "等于",
        value: "eq",
      },
      {
        label: "不等于",
        value: "ne",
      },
      {
        label: "为空",
        value: "empty",
      },
      {
        label: "不为空",
        value: "not_empty",
      },
      {
        label: "等于任意一个",
        value: "in",
      },
      {
        label: "不等于任意一个",
        value: "nin",
      },
    ],
  },
  Created: {
    options: [
      {
        label: "等于",
        value: "eq",
      },
      {
        label: "不等于",
        value: "ne",
      },
      {
        label: "为空",
        value: "empty",
      },
      {
        label: "不为空",
        value: "not_empty",
      },
      {
        label: "等于任意一个",
        value: "in",
      },
      {
        label: "不等于任意一个",
        value: "nin",
      },
    ],
  },
  Updated: {
    options: [
      {
        label: "等于",
        value: "eq",
      },
      {
        label: "不等于",
        value: "ne",
      },
      {
        label: "为空",
        value: "empty",
      },
      {
        label: "不为空",
        value: "not_empty",
      },
      {
        label: "等于任意一个",
        value: "in",
      },
      {
        label: "不等于任意一个",
        value: "nin",
      },
    ],
  },
};
